import { useTileDataContext } from '~/contexts/TileDataContext';
import abbreviateNumber from '~/utilities/abbreviateNumber';

export default function TrimMileage() {
  const {
    tileData: { trim, mileage = 0 }
  } = useTileDataContext();

  return (
    <p className="t-body-s truncate" data-qa="trim-mileage">
      {trim} <span className="mx-4">•</span>{' '}
      <span>{abbreviateNumber(mileage)} mi</span>
    </p>
  );
}
